import { openDB, IDBPDatabase } from 'idb';

const DB_NAME = 'docs-previews';
const STORE = 'previews';
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDb(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE)) {
          db.createObjectStore(STORE);
        }
      },
    });
  }
  return dbPromise;
}

/**
 * Tiny IndexedDB-backed cache for generated PDF preview thumbnails.
 *
 * Keyed by content checksum so the cache survives file renames and is shared
 * across browser tabs. Storage is unbounded; entries currently never expire.
 * If size becomes a concern we can add an LRU sweep later (or roll the cache
 * over to a SW-managed Cache API store when the offline workstream lands).
 */
export const previewCache = {
  async get(checksum: string): Promise<Blob | undefined> {
    const db = await getDb();
    return db.get(STORE, checksum);
  },
  async put(checksum: string, blob: Blob): Promise<void> {
    const db = await getDb();
    await db.put(STORE, blob, checksum);
  },
  async delete(checksum: string): Promise<void> {
    const db = await getDb();
    await db.delete(STORE, checksum);
  },
  async clear(): Promise<void> {
    const db = await getDb();
    await db.clear(STORE);
  },
};
